export default "__VITE_PUBLIC_ASSET__afb32fb6__"